import { Divider, Menu, MenuItem } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getInitials } from "../../assets/helperFunctions";
import ArrowDownIcon from "../../assets/images/arrowDown.png";
import ArrowRightIcon from "../../assets/images/arrowRight.png";
import ArrowUpIcon from "../../assets/images/arrowUp.png";
import { useStyles } from "../../assets/jss/DriverDetails";
import DateTime from "../../components/DateTime/DateTime";
import { EntityAccess, RBAC_CODE, ScoreTrend, UserLicenseView } from "../../config/app-globals.enum";
import { getLicenseExpireSoonPeriod, getUserRBAC } from "../../services/LocalStorageService";
import CustomAvatar from "../CustomComponents/CustomAvatar/CustomAvatar";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useHistory } from "react-router-dom";
import LicenseDetailsDialog from '../Dialogs/LicenseDetails/LicenseDetails';
import { adminGetDriverNotes } from '../../services/AdminUserService';
import { dateDiffInDays } from '../../config/app-global-method';
import DriverNotePopup from '../DriverNotePopup/DriverNotePopup';
import { GetUserLicenseAPI } from '../../services/LicenseCheckService';

export default function DriverDetails(props) {
  const { t } = useTranslation();
  const classes = useStyles();

  const params = useParams();
  const [licenseDialogOpen, setLicenseDialogOpen] = useState(false);
  const [isLicenseAdded, setIsLicenseAdded] = useState(false);
  const [isGetLicenseApi, setIsGetLicenseApi] = useState(false);
  const [isGetLicenseApiFailed, setIsGetLicenseApiFailed] = useState(true);
  const [licenseApiLoading, setLicenseApiLoading] = useState(false);
  const [isLicenseExpired, setIsLicenseExpired] = useState(false);
  const [isLicenseExpiringSoon, setIsLicenseExpiringSoon] = useState(false);
  const [licenseData, setLicenseData] = useState({ id: "", licenseList: [] });
  const [licenseExpireSoonPeriod] = useState(getLicenseExpireSoonPeriod());
  const [isAddLicense, setIsAddLicense] = useState(true);
  const [getRBAC_UserImpersonation] = React.useState(
    getUserRBAC(RBAC_CODE.USER_IMPERSONATION, props)
  );
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [driverDetails, setDriverDetails] = useState({
    loading: true,
    data: {
      requestedUserId: "",
      userName: "",
      userEmail: "",
      praisoRankTrend: 0,
      messageStatus: "",
      userCreatedOn: "",
      praisoRank: 0,
      groupName: "",
      status: 0
    },
    driverRecordFound: true,
    driverDetailsErrorMessage: "",
  });

  useEffect(() => {
    setDriverDetails(props.data);
    if (props?.data?.data?.requestedUserId) {
      getLicenseData();
      getNoteData();
    }
  }, [props.data]);

  useEffect(() => {
    setIsApiFailed(props.isApiFailed);
  }, [props.isApiFailed]);

  const openInImpersonationTab = () => {
    var w = window.open(`/impersonation/${driverDetails.data.requestedUserId}/userdetails/${driverDetails.data.requestedUserId}`, `${(new Date()).getTime()}`);
    w.onload = function () {
      w.document.title = driverDetails.data.userName;
    }
  }

  const openAddLicenseDialog = () => {
    setLicenseDialogOpen(true);
  }

  const licenseDetailsDialogFunc = (isOpen, action) => {
    setLicenseDialogOpen(isOpen);
    if (action) {
      getLicenseData();
    }
  };

  async function getLicenseData() {
    setLicenseApiLoading(true);
    const data = await GetUserLicenseAPI(props.data.data.requestedUserId, UserLicenseView.DEFAULT);
    setLicenseApiLoading(false);
    if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
      if (data.content.licenseList.length) {
        setLicenseData(data.content);
        setIsLicenseAdded(true);
        if (data.content.licenseList[0].expiryDate) {
          setIsLicenseExpired(new Date(data.content.licenseList[0].expiryDate) < new Date() ? true : false);
          let expiryPeriod = dateDiffInDays(new Date(), new Date(data.content.licenseList[0].expiryDate));
          setIsLicenseExpiringSoon(expiryPeriod <= licenseExpireSoonPeriod ? true : false);
        }
      } else {
        setLicenseData({ id: "", licenseList: [] });
        setIsLicenseAdded(false);
      }
      setIsGetLicenseApi(true);
      setIsGetLicenseApiFailed(false);
    } else {
      setIsGetLicenseApi(false);
      setIsGetLicenseApiFailed(true);
    }

  }

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [noteData, setNoteData] = useState({ noteList: [] });
  const [isNoteAdded, setIsNoteAdded] = useState(false);
  const [isGetNoteApi, setIsGetNoteApi] = useState(false);
  const [isGetNoteApiFailed, setIsGetNoteApiFailed] = useState(false);

  const noteDetailsDialogFunc = (isOpen, action) => {
    setDrawerOpen(isOpen);
    if (action) {
      getNoteData();
    }
  };

  async function getNoteData() {
    const data = await adminGetDriverNotes(props.data.data.requestedUserId, params);
    if (data && (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
      if (data.content.length) {
        // data.content.find(o => o.readStatus === 0) ? setIsNoteAdded(true) : setIsNoteAdded(false);
        setNoteData({ noteList: data.content });
        setIsNoteAdded(true);
      } else {
        setNoteData({ noteList: data.content });
        setIsNoteAdded(false);
      }
      setIsGetNoteApi(true);
      setIsGetNoteApiFailed(false);
    } else {
      setIsGetNoteApi(false);
      setIsGetNoteApiFailed(true);
    }
  }

  return (
    <>
      {driverDetails && driverDetails.loading && !isApiFailed && (
        <CustomPaper
          elevation={0}
          square
          className={classes.driverInfoContailer}
          style={{ padding: "2em" }}
        >
          <CustomCircularProgress
            style={{ margin: "0 auto", alignSelf: "center" }}
          />
        </CustomPaper>
      )}
      {!driverDetails.loading && !isApiFailed && (
        <CustomPaper elevation={0} square className={classes.driverInfoItem}>
          {getRBAC_UserImpersonation &&
            getRBAC_UserImpersonation.isAccessible === EntityAccess.ALLOWED ? (
            <DriverMenus
              {...props}
              openInImpersonationTab={openInImpersonationTab}
              driverDetails={driverDetails}
              licenseDialogOpen={licenseDialogOpen}
              setLicenseDialogOpen={setLicenseDialogOpen}
              isLicenseAdded={isLicenseAdded}
              noteDetailsDialogFunc={noteDetailsDialogFunc}
              isNoteAdded={isNoteAdded}
            />
          ) : null}
          <div className={classes.driverInfoCard}>
            <CustomBox className={classes.driverDetails}>
              <CustomAvatar
                className={
                  props.isExpandView
                    ? classes.driverAvatar
                    : classes.driverAvatarExpanded
                }
              >
                {getInitials(driverDetails.data.userName)}
              </CustomAvatar>
              <CustomBox>
                <CustomTypography
                  component="h1"
                  variant="h5"
                  className={classes.driverName}
                >
                  {driverDetails.data.userName}
                </CustomTypography>
                <CustomTypography className={classes.driverEmail}>
                  <span>{driverDetails.data.userEmail}</span>
                </CustomTypography>
                {props.isExpandView ? (
                  <>
                    <CustomBox className={classes.activeSinceContainer}>
                      <CustomTypography className={classes.driverEmail}>
                        <span>
                          {t("ACTIVE_SINCE")}{" "}
                          <DateTime
                            inputDate={driverDetails.data.userCreatedOn}
                            returnFormat="MMMM"
                          />
                          ,{" "}
                          <DateTime
                            inputDate={driverDetails.data.userCreatedOn}
                            returnFormat="YYYY"
                          />
                        </span>
                      </CustomTypography>
                      <CustomBox sx={{ mx: 1 }}>
                        <Divider orientation="vertical" />
                      </CustomBox>
                      <CustomTypography className={classes.statusText}>
                        <span>
                          {t("STATUS")} {"-"}{" "}
                          {driverDetails.data.messageStatus}
                        </span>
                      </CustomTypography>
                    </CustomBox>
                  </>
                ) : null}
              </CustomBox>
            </CustomBox>

            {props.isExpandView ? (
              licenseApiLoading ? (
                <CustomPaper
                  elevation={0}
                  square
                  className={classes.driverInfoContailer}
                  style={{ padding: "2em" }}
                >
                  <CustomCircularProgress
                    style={{ margin: "0 auto", alignSelf: "center" }}
                  />
                </CustomPaper>
              ) : isGetLicenseApi ? (
                isLicenseAdded ? (
                  <CustomGrid container>
                    <CustomGrid item xs={2}></CustomGrid>
                    <CustomGrid item xs={10}>
                      <CustomBox className={classes.licenceDetailsCard}>
                        <CustomGrid
                          container
                          className={classes.licenceDetailsWrapper}
                        >
                          <CustomGrid
                            item
                            xs={5}
                            className={classes.licenseNoBlock}
                          >
                            <CustomTypography
                              component="h1"
                              variant="h5"
                              className={classes.licenceHead}
                            >
                              {t("LICENSE_NO")}
                            </CustomTypography>
                            {licenseData?.licenseList[0]?.isDefault ? (
                              <CustomTypography className={classes.tag}>
                                {t("DEFAULT")}
                              </CustomTypography>
                            ) : null}
                            {isLicenseExpired ? (
                              <CustomTypography className={classes.expiryTag}>
                                {t("EXPIRED")}
                              </CustomTypography>
                            ) : isLicenseExpiringSoon ? (
                              <CustomTypography className={classes.expiryTag}>
                                {t("EXPIRING_SOON")}
                              </CustomTypography>
                            ) : null}
                            <CustomTypography
                              component="h1"
                              variant="h5"
                              className={classes.licenceNumberText}
                            >
                              {licenseData?.licenseList[0]?.licenseInsertionType === 0 ? licenseData.licenseList[0].licenseNo : t('WAITING_FOR_ECONSENT')}
                            </CustomTypography>
                          </CustomGrid>
                          <CustomGrid
                            item
                            xs={4}
                            className={classes.licenceExpiry}
                          >
                            <CustomTypography
                              component="h1"
                              variant="h5"
                              className={classes.licenceHead}
                            >
                              {t("EXPIRY_DATE")}
                            </CustomTypography>
                            <CustomBox
                              style={{ display: "flex" }}
                              className={classes.licenceContent}
                            >
                              {licenseData?.licenseList[0]?.expiryDate !==
                                undefined &&
                                licenseData?.licenseList[0]?.expiryDate !==
                                null &&
                                licenseData?.licenseList[0]?.expiryDate.length >
                                0 ? (
                                <>
                                  <DateTime
                                    inputDate={
                                      licenseData?.licenseList[0]?.expiryDate
                                    }
                                    returnFormat="DD MMM"
                                  />
                                  ,
                                  <div style={{ marginLeft: ".25rem" }}></div>
                                  <DateTime
                                    inputDate={
                                      licenseData?.licenseList[0]?.expiryDate
                                    }
                                    returnFormat="YYYY"
                                  />
                                </>
                              ) : (
                                "-"
                              )}
                            </CustomBox>
                          </CustomGrid>
                          <CustomGrid
                            item
                            xs={1}
                            className={classes.licenceExpiry}
                          >
                            <CustomTypography
                              component="h1"
                              variant="h5"
                              className={classes.licenceHead}
                            >
                              {t("POINTS")}
                            </CustomTypography>
                            <CustomTypography
                              component="h1"
                              variant="h5"
                              className={classes.licenceContent}
                            >
                              {licenseData?.licenseList[0]?.points >= 0
                                ? licenseData.licenseList[0].points
                                : "-"}
                            </CustomTypography>
                          </CustomGrid>
                        </CustomGrid>
                      </CustomBox>
                    </CustomGrid>
                  </CustomGrid>
                ) : (
                  <CustomGrid container>
                    <CustomGrid item xs={2}></CustomGrid>
                    <CustomGrid item xs={10}>
                      <CustomButton
                        onClick={() => openAddLicenseDialog()}
                        className={classes.addLicenseBtn}
                      >
                        {" "}
                        {t("ADD_LICENSE_DETAILS")}{" "}
                      </CustomButton>
                    </CustomGrid>
                  </CustomGrid>
                )
              ) : null
            ) : null}
            <CustomBox className={classes.driverScoreInfoCard}>
              <CustomBox
                className={
                  props.isExpandView
                    ? classes.driverInfoCardExpand
                    : classes.driverInfoCardCollpase
                }
              >
                <CustomGrid container>
                  <CustomGrid
                    item
                    xs={3}
                    className={classes.driverPraisoRank}
                  >
                    <CustomBox>
                      {driverDetails.data.praisoRankTrend ===
                        ScoreTrend.UP ? (
                        <img
                          src={ArrowUpIcon}
                          className={classes.arrowUpIcon}
                          alt="Up Arrow"
                        />
                      ) : driverDetails.data.praisoRankTrend ===
                        ScoreTrend.NONE ? (
                        <img
                          src={ArrowRightIcon}
                          className={classes.arrowRightIcon}
                          alt="Equal Arrow"
                        />
                      ) : (
                        <img
                          src={ArrowDownIcon}
                          className={classes.arrowDownIcon}
                          alt="Down Arrow"
                        />
                      )}
                    </CustomBox>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      {driverDetails.data.praisoRank !== undefined &&
                        driverDetails.data.praisoRank !== null
                        ? `#${driverDetails.data.praisoRank}`
                        : "N/A"}{" "}
                      <br />
                      <span>{t("RANK")}</span>
                    </CustomTypography>
                  </CustomGrid>
                  <CustomBox sx={{ mx: 1 }}>
                    <Divider variant="middle" orientation="vertical" />
                  </CustomBox>
                  <CustomGrid item xs={3}>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      {driverDetails.data.groupName !== undefined &&
                        driverDetails.data.groupName !== null
                        ? `#${driverDetails.data.groupName}`
                        : "N/A"}{" "}
                      <br />
                      <span>{t("GROUP")}</span>
                    </CustomTypography>
                  </CustomGrid>
                </CustomGrid>
              </CustomBox>
            </CustomBox>
          </div>
        </CustomPaper>
      )}

      {isApiFailed && (
        <CustomPaper elevation={0} square className={classes.driverCard}>
          <CustomAvatar
            className={clsx(
              classes.driverAvatar,
              classes.driverAvatarDisabled
            )}
          ></CustomAvatar>
          <CustomGrid>
            <CustomTypography
              component="h1"
              variant="h5"
              className={clsx(
                classes.driverName,
                classes.driverNameApiFailed
              )}
            >
              <CustomSkeleton animation="wave" width={120} height={50} />
            </CustomTypography>
            <CustomTypography
              component="h1"
              variant="h5"
              className={classes.driverEmail}
            >
              <CustomSkeleton animation="wave" width={180} height={30} />
            </CustomTypography>

            <CustomGrid
              container
              spacing={0}
              alignItems="center"
              className={classes.rankingContainer}
            >
              <CustomGrid item className={classes.ranking}>
                <CustomGrid container spacing={0}>
                  <CustomGrid item>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      <CustomSkeleton
                        animation="wave"
                        width={70}
                        height={40}
                      />
                      <span>{t("PRAISO_RANK")}</span>
                    </CustomTypography>
                  </CustomGrid>
                  <CustomGrid item>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      <CustomSkeleton
                        animation="wave"
                        width={70}
                        height={40}
                      />
                      <span>{t("DRIVER_SCORE")}</span>
                    </CustomTypography>
                  </CustomGrid>
                </CustomGrid>
              </CustomGrid>
              <CustomGrid item className={classes.ranking}>
                <CustomGrid container spacing={0}>
                  <CustomGrid item>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      <CustomSkeleton
                        animation="wave"
                        width={70}
                        height={40}
                      />
                      <span>{t("ENGAGEMENT_RANK")}</span>
                    </CustomTypography>
                  </CustomGrid>
                  <CustomGrid item>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      <CustomSkeleton
                        animation="wave"
                        width={70}
                        height={40}
                      />
                      <span>{t("ENGAGEMENT_SCORE")}</span>
                    </CustomTypography>
                  </CustomGrid>
                </CustomGrid>
              </CustomGrid>
              <CustomGrid
                item
                className={clsx(classes.ranking, classes.rankingLast)}
              >
                <CustomGrid container spacing={0}>
                  <CustomGrid item>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      <CustomSkeleton
                        animation="wave"
                        width={70}
                        height={40}
                      />
                      <span>{t("CONTENT_ACTIVE")}</span>
                    </CustomTypography>
                  </CustomGrid>
                  <CustomGrid item>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.rankingText}
                    >
                      <CustomSkeleton
                        animation="wave"
                        width={70}
                        height={40}
                      />
                      <span>{t("CONTENT_COMPLETED")}</span>
                    </CustomTypography>
                  </CustomGrid>
                </CustomGrid>
              </CustomGrid>
            </CustomGrid>
          </CustomGrid>
          <CustomTypography
            component="h1"
            variant="h5"
            className={classes.statusMessage}
          >
            <span></span> {driverDetails.data.status}
          </CustomTypography>
        </CustomPaper>
      )}
      {licenseDialogOpen ? (
        <LicenseDetailsDialog
          dialogOpen={licenseDialogOpen}
          dialogClose={(isOpen, confirmDelete) =>
            licenseDetailsDialogFunc(isOpen, confirmDelete)
          }
          isLicenseAdded={isLicenseAdded}
          // isLicenseAdded={false}
          setIsLicenseAdded={setIsLicenseAdded}
          userId={driverDetails.data.requestedUserId}
          getLicenseData={getLicenseData}
          isAddLicense={isAddLicense}
          setIsAddLicense={setIsAddLicense}
        />
      ) : null}
      <DriverNotePopup
        open={drawerOpen}
        anchor={"right"}
        // onClose={() => setDrawerOpen(false)}
        onClose={(isOpen, confirmDelete) => noteDetailsDialogFunc(isOpen, confirmDelete)}
        isNoteAdded={isNoteAdded}
        setIsNoteAdded={setIsNoteAdded}
        driverId={driverDetails.data.requestedUserId}
        getNoteData={getNoteData}
      />
    </>
  );
}

function DriverMenus(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  let options = [];

  if (!props.isLicenseAdded && !props.isNoteAdded) {
    options = [
      'VIEW_AS_DRIVER',
      'EDIT_DRIVER',
    ];
  } else if (!props.isLicenseAdded && props.isNoteAdded) {
    options = [
      'VIEW_AS_DRIVER',
      'EDIT_DRIVER',
      'ADD_NOTE'
    ];
  } else if (props.isLicenseAdded && !props.isNoteAdded) {
    options = [
      'VIEW_AS_DRIVER',
      'EDIT_DRIVER',
      'ADD_VIEW_LICENSE',
    ];
  } else {
    options = [
      'VIEW_AS_DRIVER',
      'EDIT_DRIVER',
      'ADD_VIEW_LICENSE',
      'ADD_NOTE'
    ];
  }

  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    setAnchorEl(null);
    if (e?.target?.id) {
      if (e.target.id === "VIEW_AS_DRIVER") {
        props.openInImpersonationTab();
      } else if (e.target.id === "EDIT_DRIVER") {
        // window.location.href = `/admin/users/edit/${props.driverDetails.data.requestedUserId}`;
        history.push(`/admin/users/edit/${props.driverDetails.data.requestedUserId}`);
      } else if (e.target.id === "ADD_VIEW_LICENSE") {
        props.setLicenseDialogOpen(true);
      } else if (e.target.id === "ADD_NOTE") {
        props.noteDetailsDialogFunc(true, false)
      }
    }
  };

  return (
    <div className={classes.editIcon}>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon style={{ height: '46px', width: '46px', color: '#d8d8d8' }} />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem id={option} key={option} value={option} onClick={handleClose}>
            {t(option)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
